export const HIGH_RISK = 'HIGH_RISK';
export const LOW_RISK = 'LOW_RISK';
export const UNCERTAIN_RISK = 'UNCERTAIN_RISK';
